import { PostsDataType } from "services/apis/cnt2/post-api";

const Square = () => {
  return (
    <>
      <div></div>
    </>
  );
};

export default Square;
